import React, { useState } from 'react'
import moment from 'moment'
import {
  DateRangePickerComponent,
  PresetsDirective,
  PresetDirective,
} from '@syncfusion/ej2-react-calendars'
import './DashboardStyle.css'

type DashboardCalendarProps = {
  classNameCalendar?: string
}

function DashboardCalendar({
  classNameCalendar,
}: DashboardCalendarProps): React.ReactElement {
  const [dateRange, setDateRange] = useState({
    start: moment().startOf('week').toDate(),
    end: moment().startOf('week').add(6, 'days').toDate(),
  })

  // This Week
  const weekStart = moment().startOf('week').toDate()
  const weekEnd = moment().startOf('week').add(6, 'days').toDate()
  // Last Week
  const lastWeekStart = moment().subtract(1, 'week').startOf('week').toDate()
  const lastWeekEnd = moment()
    .subtract(1, 'week')
    .startOf('week')
    .add(6, 'days')
    .toDate()
  // Next Week
  const nextWeekStart = moment().add(1, 'week').startOf('week').toDate()
  const nextWeekEnd = moment()
    .add(1, 'week')
    .startOf('week')
    .add(6, 'days')
    .toDate()

  const handleDateRangeChange = (e: any): void => {
    if (e.startDate && e.endDate) {
      setDateRange({
        start: e.startDate,
        end: e.endDate,
      })
    } else {
      setDateRange({
        start: moment().startOf('week').toDate(),
        end: moment().startOf('week').add(6, 'days').toDate(),
      })
    }
  }

  return (
    <div className="control-pane">
      <div className="control-section">
        <div className={`${classNameCalendar || 'calendar-control-section'}`}>
          <DateRangePickerComponent
            placeholder="Select a range"
            value={[dateRange.start, dateRange.end]}
            change={handleDateRangeChange}
            format="MMMM dd, yyyy"
          >
            <PresetsDirective>
              <PresetDirective
                label="This Week"
                start={weekStart}
                end={weekEnd}
              />
              <PresetDirective
                label="Last Week"
                start={lastWeekStart}
                end={lastWeekEnd}
              />
              <PresetDirective
                label="Next Week"
                start={nextWeekStart}
                end={nextWeekEnd}
              />
            </PresetsDirective>
          </DateRangePickerComponent>
        </div>
      </div>
    </div>
  )
}

export default DashboardCalendar
